export const getProductsByIds = (ids) => `
  query getProductsByIds {
    nodes(ids: [${ids.join(',')}]) {
      ... on Product {
        id
        title
        handle
        images(first: 1) {
          edges {
            node {
              url
              altText
            }
          }
        }
        metafields(identifiers: [{namespace: "discount_banner", key: "discount_message"}, {namespace: "discount_banner", key: "discount_text_colour"}, {namespace: "discount_banner", key: "discount_banner_colour"}, {namespace: "discount_banner", key: "discount_text_colour"}, {namespace: "global", key: "is_sample_kit"}, {namespace: "global", key: "linked_sample"}, {namespace: "global", key: "sample_kit_weight"}]) {
          id
          value
          description
          namespace
          key
        }
        variants(first: 250) {
          edges {
            node {
              id
              title
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`;